const deliveryDateData = 
{
  data: [
    {
      "Country Name": "Afghanistan",
      "Country Code": "af",
      "Priority Shipping Order Ships": 4,
      "Priority Shipping Arrives": 7,
      "Standard Shipping Order Ships": 4,
      "Standard Shipping Arrives": 9
    },
    {
      "Country Name": "Åland Islands",
      "Country Code": "ax",
      "Priority Shipping Order Ships": 4,
      "Priority Shipping Arrives": 7,
      "Standard Shipping Order Ships": 4,
      "Standard Shipping Arrives": 9
    },
    {
      "Country Name": "Albania",
      "Country Code": "al",
      "Priority Shipping Order Ships": 4,
      "Priority Shipping Arrives": 7,
      "Standard Shipping Order Ships": 4,
      "Standard Shipping Arrives": 9
    },
    {
      "Country Name": "Algeria",
      "Country Code": "dz",
      "Priority Shipping Order Ships": 4,
      "Priority Shipping Arrives": 7,
      "Standard Shipping Order Ships": 4,
      "Standard Shipping Arrives": 9
    },
    {
      "Country Name": "American Samoa",
      "Country Code": "as",
      "Priority Shipping Order Ships": 4,
      "Priority Shipping Arrives": 7,
      "Standard Shipping Order Ships": 4,
      "Standard Shipping Arrives": 9
    },
    {
      "Country Name": "Andorra",
      "Country Code": "ad",
      "Priority Shipping Order Ships": 4,
      "Priority Shipping Arrives": 7,
      "Standard Shipping Order Ships": 4,
      "Standard Shipping Arrives": 9
    },
    {
      "Country Name": "Angola",
      "Country Code": "ao",
      "Priority Shipping Order Ships": 4,
      "Priority Shipping Arrives": 7,
      "Standard Shipping Order Ships": 4,
      "Standard Shipping Arrives": 9
    },
    {
      "Country Name": "Anguilla",
      "Country Code": "ai",
      "Priority Shipping Order Ships": 4,
      "Priority Shipping Arrives": 7,
      "Standard Shipping Order Ships": 4,
      "Standard Shipping Arrives": 9
    },
    {
      "Country Name": "Antarctica",
      "Country Code": "aq",
      "Priority Shipping Order Ships": 4,
      "Priority Shipping Arrives": 7,
      "Standard Shipping Order Ships": 4,
      "Standard Shipping Arrives": 9
    },
    {
      "Country Name": "Antigua and Barbuda",
      "Country Code": "ag",
      "Priority Shipping Order Ships": 4,
      "Priority Shipping Arrives": 7,
      "Standard Shipping Order Ships": 4,
      "Standard Shipping Arrives": 9
    },
    {
      "Country Name": "Argentina",
      "Country Code": "ar",
      "Priority Shipping Order Ships": 4,
      "Priority Shipping Arrives": 7,
      "Standard Shipping Order Ships": 4,
      "Standard Shipping Arrives": 9
    },
    {
      "Country Name": "Armenia",
      "Country Code": "am",
      "Priority Shipping Order Ships": 4,
      "Priority Shipping Arrives": 7,
      "Standard Shipping Order Ships": 4,
      "Standard Shipping Arrives": 9
    },
    {
      "Country Name": "Aruba",
      "Country Code": "aw",
      "Priority Shipping Order Ships": 4,
      "Priority Shipping Arrives": 7,
      "Standard Shipping Order Ships": 4,
      "Standard Shipping Arrives": 9
    },
    {
      "Country Name": "Australia",
      "Country Code": "au",
      "Priority Shipping Order Ships": 4,
      "Priority Shipping Arrives": 7,
      "Standard Shipping Order Ships": 4,
      "Standard Shipping Arrives": 9
    },
    {
      "Country Name": "Austria",
      "Country Code": "at",
      "Priority Shipping Order Ships": 4,
      "Priority Shipping Arrives": 7,
      "Standard Shipping Order Ships": 4,
      "Standard Shipping Arrives": 9
    },
    {
      "Country Name": "Azerbaijan",
      "Country Code": "az",
      "Priority Shipping Order Ships": 4,
      "Priority Shipping Arrives": 7,
      "Standard Shipping Order Ships": 4,
      "Standard Shipping Arrives": 9
    },
    {
      "Country Name": "Bahamas",
      "Country Code": "bs",
      "Priority Shipping Order Ships": 4,
      "Priority Shipping Arrives": 7,
      "Standard Shipping Order Ships": 4,
      "Standard Shipping Arrives": 9
    },
    {
      "Country Name": "Bahrain",
      "Country Code": "bh",
      "Priority Shipping Order Ships": 4,
      "Priority Shipping Arrives": 7,
      "Standard Shipping Order Ships": 4,
      "Standard Shipping Arrives": 9
    },
    {
      "Country Name": "Bangladesh",
      "Country Code": "bd",
      "Priority Shipping Order Ships": 4,
      "Priority Shipping Arrives": 7,
      "Standard Shipping Order Ships": 4,
      "Standard Shipping Arrives": 9
    },
    {
      "Country Name": "Barbados",
      "Country Code": "bb",
      "Priority Shipping Order Ships": 4,
      "Priority Shipping Arrives": 7,
      "Standard Shipping Order Ships": 4,
      "Standard Shipping Arrives": 9
    },
    {
      "Country Name": "Belarus",
      "Country Code": "by",
      "Priority Shipping Order Ships": 4,
      "Priority Shipping Arrives": 7,
      "Standard Shipping Order Ships": 4,
      "Standard Shipping Arrives": 9
    },
    {
      "Country Name": "Belgium",
      "Country Code": "be",
      "Priority Shipping Order Ships": 4,
      "Priority Shipping Arrives": 7,
      "Standard Shipping Order Ships": 4,
      "Standard Shipping Arrives": 9
    },
    {
      "Country Name": "Belize",
      "Country Code": "bz",
      "Priority Shipping Order Ships": 4,
      "Priority Shipping Arrives": 7,
      "Standard Shipping Order Ships": 4,
      "Standard Shipping Arrives": 9
    },
    {
      "Country Name": "Benin",
      "Country Code": "bj",
      "Priority Shipping Order Ships": 4,
      "Priority Shipping Arrives": 7,
      "Standard Shipping Order Ships": 4,
      "Standard Shipping Arrives": 9
    },
    {
      "Country Name": "Bermuda",
      "Country Code": "bm",
      "Priority Shipping Order Ships": 4,
      "Priority Shipping Arrives": 7,
      "Standard Shipping Order Ships": 4,
      "Standard Shipping Arrives": 9
    },
    {
      "Country Name": "Bhutan",
      "Country Code": "bt",
      "Priority Shipping Order Ships": 4,
      "Priority Shipping Arrives": 7,
      "Standard Shipping Order Ships": 4,
      "Standard Shipping Arrives": 9
    },
    {
      "Country Name": "Bolivia (Plurinational State of)",
      "Country Code": "bo",
      "Priority Shipping Order Ships": 4,
      "Priority Shipping Arrives": 7,
      "Standard Shipping Order Ships": 4,
      "Standard Shipping Arrives": 9
    },
    {
      "Country Name": "Bonaire, Sint Eustatius and Sab",
      "Country Code": "bq",
      "Priority Shipping Order Ships": 4,
      "Priority Shipping Arrives": 7,
      "Standard Shipping Order Ships": 4,
      "Standard Shipping Arrives": 9
    },
    {
      "Country Name": "Bosnia and Herzegovina",
      "Country Code": "ba",
      "Priority Shipping Order Ships": 4,
      "Priority Shipping Arrives": 7,
      "Standard Shipping Order Ships": 4,
      "Standard Shipping Arrives": 9
    },
    {
      "Country Name": "Botswana",
      "Country Code": "bw",
      "Priority Shipping Order Ships": 4,
      "Priority Shipping Arrives": 7,
      "Standard Shipping Order Ships": 4,
      "Standard Shipping Arrives": 9
    },
    {
      "Country Name": "Bouvet Island",
      "Country Code": "bv",
      "Priority Shipping Order Ships": 4,
      "Priority Shipping Arrives": 7,
      "Standard Shipping Order Ships": 4,
      "Standard Shipping Arrives": 9
    },
    {
      "Country Name": "Brazil",
      "Country Code": "br",
      "Priority Shipping Order Ships": 4,
      "Priority Shipping Arrives": 7,
      "Standard Shipping Order Ships": 4,
      "Standard Shipping Arrives": 9
    },
    {
      "Country Name": "British Indian Ocean Territory",
      "Country Code": "io",
      "Priority Shipping Order Ships": 4,
      "Priority Shipping Arrives": 7,
      "Standard Shipping Order Ships": 4,
      "Standard Shipping Arrives": 9
    },
    {
      "Country Name": "Brunei Darussalam",
      "Country Code": "bn",
      "Priority Shipping Order Ships": 4,
      "Priority Shipping Arrives": 7,
      "Standard Shipping Order Ships": 4,
      "Standard Shipping Arrives": 9
    },
    {
      "Country Name": "Bulgaria",
      "Country Code": "bg",
      "Priority Shipping Order Ships": 4,
      "Priority Shipping Arrives": 7,
      "Standard Shipping Order Ships": 4,
      "Standard Shipping Arrives": 9
    },
    {
      "Country Name": "Burkina Faso",
      "Country Code": "bf",
      "Priority Shipping Order Ships": 4,
      "Priority Shipping Arrives": 7,
      "Standard Shipping Order Ships": 4,
      "Standard Shipping Arrives": 9
    },
    {
      "Country Name": "Burundi",
      "Country Code": "bi",
      "Priority Shipping Order Ships": 4,
      "Priority Shipping Arrives": 7,
      "Standard Shipping Order Ships": 4,
      "Standard Shipping Arrives": 9
    },
    {
      "Country Name": "Cambodia",
      "Country Code": "kh",
      "Priority Shipping Order Ships": 4,
      "Priority Shipping Arrives": 7,
      "Standard Shipping Order Ships": 4,
      "Standard Shipping Arrives": 9
    },
    {
      "Country Name": "Cameroon",
      "Country Code": "cm",
      "Priority Shipping Order Ships": 4,
      "Priority Shipping Arrives": 7,
      "Standard Shipping Order Ships": 4,
      "Standard Shipping Arrives": 9
    },
    {
      "Country Name": "Canada",
      "Country Code": "ca",
      "Priority Shipping Order Ships": 4,
      "Priority Shipping Arrives": 7,
      "Standard Shipping Order Ships": 4,
      "Standard Shipping Arrives": 9
    },
    {
      "Country Name": "Cape Verde",
      "Country Code": "cv",
      "Priority Shipping Order Ships": 4,
      "Priority Shipping Arrives": 7,
      "Standard Shipping Order Ships": 4,
      "Standard Shipping Arrives": 9
    },
    {
      "Country Name": "Cayman Islands",
      "Country Code": "ky",
      "Priority Shipping Order Ships": 4,
      "Priority Shipping Arrives": 7,
      "Standard Shipping Order Ships": 4,
      "Standard Shipping Arrives": 9
    },
    {
      "Country Name": "Central African Republic",
      "Country Code": "cf",
      "Priority Shipping Order Ships": 4,
      "Priority Shipping Arrives": 7,
      "Standard Shipping Order Ships": 4,
      "Standard Shipping Arrives": 9
    },
    {
      "Country Name": "Chad",
      "Country Code": "td",
      "Priority Shipping Order Ships": 4,
      "Priority Shipping Arrives": 7,
      "Standard Shipping Order Ships": 4,
      "Standard Shipping Arrives": 9
    },
    {
      "Country Name": "Chile",
      "Country Code": "cl",
      "Priority Shipping Order Ships": 4,
      "Priority Shipping Arrives": 7,
      "Standard Shipping Order Ships": 4,
      "Standard Shipping Arrives": 9
    },
    {
      "Country Name": "China",
      "Country Code": "cn",
      "Priority Shipping Order Ships": 4,
      "Priority Shipping Arrives": 7,
      "Standard Shipping Order Ships": 4,
      "Standard Shipping Arrives": 9
    },
    {
      "Country Name": "Christmas Island",
      "Country Code": "cx",
      "Priority Shipping Order Ships": 4,
      "Priority Shipping Arrives": 7,
      "Standard Shipping Order Ships": 4,
      "Standard Shipping Arrives": 9
    },
    {
      "Country Name": "Cocos (Keeling) Islands",
      "Country Code": "cc",
      "Priority Shipping Order Ships": 4,
      "Priority Shipping Arrives": 7,
      "Standard Shipping Order Ships": 4,
      "Standard Shipping Arrives": 9
    },
    {
      "Country Name": "Colombia",
      "Country Code": "co",
      "Priority Shipping Order Ships": 4,
      "Priority Shipping Arrives": 7,
      "Standard Shipping Order Ships": 4,
      "Standard Shipping Arrives": 9
    },
    {
      "Country Name": "Comoros",
      "Country Code": "km",
      "Priority Shipping Order Ships": 4,
      "Priority Shipping Arrives": 7,
      "Standard Shipping Order Ships": 4,
      "Standard Shipping Arrives": 9
    },
    {
      "Country Name": "Congo",
      "Country Code": "cg",
      "Priority Shipping Order Ships": 4,
      "Priority Shipping Arrives": 7,
      "Standard Shipping Order Ships": 4,
      "Standard Shipping Arrives": 9
    },
    {
      "Country Name": "Congo (Democratic Republic of the)",
      "Country Code": "cd",
      "Priority Shipping Order Ships": 4,
      "Priority Shipping Arrives": 7,
      "Standard Shipping Order Ships": 4,
      "Standard Shipping Arrives": 9
    },
    {
      "Country Name": "Cook Islands",
      "Country Code": "ck",
      "Priority Shipping Order Ships": 4,
      "Priority Shipping Arrives": 7,
      "Standard Shipping Order Ships": 4,
      "Standard Shipping Arrives": 9
    },
    {
      "Country Name": "Costa Rica",
      "Country Code": "cr",
      "Priority Shipping Order Ships": 4,
      "Priority Shipping Arrives": 7,
      "Standard Shipping Order Ships": 4,
      "Standard Shipping Arrives": 9
    },
    {
      "Country Name": "Croatia",
      "Country Code": "hr",
      "Priority Shipping Order Ships": 4,
      "Priority Shipping Arrives": 7,
      "Standard Shipping Order Ships": 4,
      "Standard Shipping Arrives": 9
    },
    {
      "Country Name": "Cuba",
      "Country Code": "cu",
      "Priority Shipping Order Ships": 4,
      "Priority Shipping Arrives": 7,
      "Standard Shipping Order Ships": 4,
      "Standard Shipping Arrives": 9
    },
    {
      "Country Name": "Curaçao",
      "Country Code": "cw",
      "Priority Shipping Order Ships": 4,
      "Priority Shipping Arrives": 7,
      "Standard Shipping Order Ships": 4,
      "Standard Shipping Arrives": 9
    },
    {
      "Country Name": "Cyprus",
      "Country Code": "cy",
      "Priority Shipping Order Ships": 4,
      "Priority Shipping Arrives": 7,
      "Standard Shipping Order Ships": 4,
      "Standard Shipping Arrives": 9
    },
    {
      "Country Name": "Czech Republic",
      "Country Code": "cz",
      "Priority Shipping Order Ships": 4,
      "Priority Shipping Arrives": 7,
      "Standard Shipping Order Ships": 4,
      "Standard Shipping Arrives": 9
    },
    {
      "Country Name": "Côte d'Ivoire",
      "Country Code": "ci",
      "Priority Shipping Order Ships": 4,
      "Priority Shipping Arrives": 7,
      "Standard Shipping Order Ships": 4,
      "Standard Shipping Arrives": 9
    },
    {
      "Country Name": "Denmark",
      "Country Code": "dk",
      "Priority Shipping Order Ships": 4,
      "Priority Shipping Arrives": 7,
      "Standard Shipping Order Ships": 4,
      "Standard Shipping Arrives": 9
    },
    {
      "Country Name": "Djibouti",
      "Country Code": "dj",
      "Priority Shipping Order Ships": 4,
      "Priority Shipping Arrives": 7,
      "Standard Shipping Order Ships": 4,
      "Standard Shipping Arrives": 9
    },
    {
      "Country Name": "Dominica",
      "Country Code": "dm",
      "Priority Shipping Order Ships": 4,
      "Priority Shipping Arrives": 7,
      "Standard Shipping Order Ships": 4,
      "Standard Shipping Arrives": 9
    },
    {
      "Country Name": "Dominican Republic",
      "Country Code": "do",
      "Priority Shipping Order Ships": 4,
      "Priority Shipping Arrives": 7,
      "Standard Shipping Order Ships": 4,
      "Standard Shipping Arrives": 9
    },
    {
      "Country Name": "Ecuador",
      "Country Code": "ec",
      "Priority Shipping Order Ships": 4,
      "Priority Shipping Arrives": 7,
      "Standard Shipping Order Ships": 4,
      "Standard Shipping Arrives": 9
    },
    {
      "Country Name": "Egypt",
      "Country Code": "eg",
      "Priority Shipping Order Ships": 4,
      "Priority Shipping Arrives": 7,
      "Standard Shipping Order Ships": 4,
      "Standard Shipping Arrives": 9
    },
    {
      "Country Name": "El Salvador",
      "Country Code": "sv",
      "Priority Shipping Order Ships": 4,
      "Priority Shipping Arrives": 7,
      "Standard Shipping Order Ships": 4,
      "Standard Shipping Arrives": 9
    },
    {
      "Country Name": "Equatorial Guinea",
      "Country Code": "gq",
      "Priority Shipping Order Ships": 4,
      "Priority Shipping Arrives": 7,
      "Standard Shipping Order Ships": 4,
      "Standard Shipping Arrives": 9
    },
    {
      "Country Name": "Eritrea",
      "Country Code": "er",
      "Priority Shipping Order Ships": 4,
      "Priority Shipping Arrives": 7,
      "Standard Shipping Order Ships": 4,
      "Standard Shipping Arrives": 9
    },
    {
      "Country Name": "Estonia",
      "Country Code": "ee",
      "Priority Shipping Order Ships": 4,
      "Priority Shipping Arrives": 7,
      "Standard Shipping Order Ships": 4,
      "Standard Shipping Arrives": 9
    },
    {
      "Country Name": "Ethiopia",
      "Country Code": "et",
      "Priority Shipping Order Ships": 4,
      "Priority Shipping Arrives": 7,
      "Standard Shipping Order Ships": 4,
      "Standard Shipping Arrives": 9
    },
    {
      "Country Name": "Falkland Islands (Malvinas)",
      "Country Code": "fk",
      "Priority Shipping Order Ships": 4,
      "Priority Shipping Arrives": 7,
      "Standard Shipping Order Ships": 4,
      "Standard Shipping Arrives": 9
    },
    {
      "Country Name": "Faroe Islands",
      "Country Code": "fo",
      "Priority Shipping Order Ships": 4,
      "Priority Shipping Arrives": 7,
      "Standard Shipping Order Ships": 4,
      "Standard Shipping Arrives": 9
    },
    {
      "Country Name": "Fiji",
      "Country Code": "fj",
      "Priority Shipping Order Ships": 4,
      "Priority Shipping Arrives": 7,
      "Standard Shipping Order Ships": 4,
      "Standard Shipping Arrives": 9
    },
    {
      "Country Name": "Finland",
      "Country Code": "fi",
      "Priority Shipping Order Ships": 4,
      "Priority Shipping Arrives": 7,
      "Standard Shipping Order Ships": 4,
      "Standard Shipping Arrives": 9
    },
    {
      "Country Name": "France",
      "Country Code": "fr",
      "Priority Shipping Order Ships": 4,
      "Priority Shipping Arrives": 7,
      "Standard Shipping Order Ships": 4,
      "Standard Shipping Arrives": 9
    },
    {
      "Country Name": "French Guiana",
      "Country Code": "gf",
      "Priority Shipping Order Ships": 4,
      "Priority Shipping Arrives": 7,
      "Standard Shipping Order Ships": 4,
      "Standard Shipping Arrives": 9
    },
    {
      "Country Name": "French Southern Territories",
      "Country Code": "tf",
      "Priority Shipping Order Ships": 4,
      "Priority Shipping Arrives": 7,
      "Standard Shipping Order Ships": 4,
      "Standard Shipping Arrives": 9
    },
    {
      "Country Name": "French polynesia",
      "Country Code": "pf",
      "Priority Shipping Order Ships": 4,
      "Priority Shipping Arrives": 7,
      "Standard Shipping Order Ships": 4,
      "Standard Shipping Arrives": 9
    },
    {
      "Country Name": "Gabon",
      "Country Code": "ga",
      "Priority Shipping Order Ships": 4,
      "Priority Shipping Arrives": 7,
      "Standard Shipping Order Ships": 4,
      "Standard Shipping Arrives": 9
    },
    {
      "Country Name": "Gambia",
      "Country Code": "gm",
      "Priority Shipping Order Ships": 4,
      "Priority Shipping Arrives": 7,
      "Standard Shipping Order Ships": 4,
      "Standard Shipping Arrives": 9
    },
    {
      "Country Name": "Georgia",
      "Country Code": "ge",
      "Priority Shipping Order Ships": 4,
      "Priority Shipping Arrives": 7,
      "Standard Shipping Order Ships": 4,
      "Standard Shipping Arrives": 9
    },
    {
      "Country Name": "Germany",
      "Country Code": "de",
      "Priority Shipping Order Ships": 4,
      "Priority Shipping Arrives": 7,
      "Standard Shipping Order Ships": 4,
      "Standard Shipping Arrives": 9
    },
    {
      "Country Name": "Ghana",
      "Country Code": "gh",
      "Priority Shipping Order Ships": 4,
      "Priority Shipping Arrives": 7,
      "Standard Shipping Order Ships": 4,
      "Standard Shipping Arrives": 9
    },
    {
      "Country Name": "Gibraltar",
      "Country Code": "gi",
      "Priority Shipping Order Ships": 4,
      "Priority Shipping Arrives": 7,
      "Standard Shipping Order Ships": 4,
      "Standard Shipping Arrives": 9
    },
    {
      "Country Name": "Greece",
      "Country Code": "gr",
      "Priority Shipping Order Ships": 4,
      "Priority Shipping Arrives": 7,
      "Standard Shipping Order Ships": 4,
      "Standard Shipping Arrives": 9
    },
    {
      "Country Name": "Greenland",
      "Country Code": "gl",
      "Priority Shipping Order Ships": 4,
      "Priority Shipping Arrives": 7,
      "Standard Shipping Order Ships": 4,
      "Standard Shipping Arrives": 9
    },
    {
      "Country Name": "Grenada",
      "Country Code": "gd",
      "Priority Shipping Order Ships": 4,
      "Priority Shipping Arrives": 7,
      "Standard Shipping Order Ships": 4,
      "Standard Shipping Arrives": 9
    },
    {
      "Country Name": "Guadeloupe",
      "Country Code": "gp",
      "Priority Shipping Order Ships": 4,
      "Priority Shipping Arrives": 7,
      "Standard Shipping Order Ships": 4,
      "Standard Shipping Arrives": 9
    },
    {
      "Country Name": "Guam",
      "Country Code": "gu",
      "Priority Shipping Order Ships": 4,
      "Priority Shipping Arrives": 7,
      "Standard Shipping Order Ships": 4,
      "Standard Shipping Arrives": 9
    },
    {
      "Country Name": "Guatemala",
      "Country Code": "gt",
      "Priority Shipping Order Ships": 4,
      "Priority Shipping Arrives": 7,
      "Standard Shipping Order Ships": 4,
      "Standard Shipping Arrives": 9
    },
    {
      "Country Name": "Guernsey",
      "Country Code": "gg",
      "Priority Shipping Order Ships": 4,
      "Priority Shipping Arrives": 7,
      "Standard Shipping Order Ships": 4,
      "Standard Shipping Arrives": 9
    },
    {
      "Country Name": "Guinea",
      "Country Code": "gn",
      "Priority Shipping Order Ships": 4,
      "Priority Shipping Arrives": 7,
      "Standard Shipping Order Ships": 4,
      "Standard Shipping Arrives": 9
    },
    {
      "Country Name": "Guinea-Bissau",
      "Country Code": "gw",
      "Priority Shipping Order Ships": 4,
      "Priority Shipping Arrives": 7,
      "Standard Shipping Order Ships": 4,
      "Standard Shipping Arrives": 9
    },
    {
      "Country Name": "Guyana",
      "Country Code": "gy",
      "Priority Shipping Order Ships": 4,
      "Priority Shipping Arrives": 7,
      "Standard Shipping Order Ships": 4,
      "Standard Shipping Arrives": 9
    },
    {
      "Country Name": "Haiti",
      "Country Code": "ht",
      "Priority Shipping Order Ships": 4,
      "Priority Shipping Arrives": 7,
      "Standard Shipping Order Ships": 4,
      "Standard Shipping Arrives": 9
    },
    {
      "Country Name": "Heard Island and McDonald Islands",
      "Country Code": "hm",
      "Priority Shipping Order Ships": 4,
      "Priority Shipping Arrives": 7,
      "Standard Shipping Order Ships": 4,
      "Standard Shipping Arrives": 9
    },
    {
      "Country Name": "Holy See",
      "Country Code": "va",
      "Priority Shipping Order Ships": 4,
      "Priority Shipping Arrives": 7,
      "Standard Shipping Order Ships": 4,
      "Standard Shipping Arrives": 9
    },
    {
      "Country Name": "Honduras",
      "Country Code": "hn",
      "Priority Shipping Order Ships": 4,
      "Priority Shipping Arrives": 7,
      "Standard Shipping Order Ships": 4,
      "Standard Shipping Arrives": 9
    },
    {
      "Country Name": "Hong Kong",
      "Country Code": "hk",
      "Priority Shipping Order Ships": 4,
      "Priority Shipping Arrives": 7,
      "Standard Shipping Order Ships": 4,
      "Standard Shipping Arrives": 9
    },
    {
      "Country Name": "Hungary",
      "Country Code": "hu",
      "Priority Shipping Order Ships": 4,
      "Priority Shipping Arrives": 7,
      "Standard Shipping Order Ships": 4,
      "Standard Shipping Arrives": 9
    },
    {
      "Country Name": "Iceland",
      "Country Code": "is",
      "Priority Shipping Order Ships": 4,
      "Priority Shipping Arrives": 7,
      "Standard Shipping Order Ships": 4,
      "Standard Shipping Arrives": 9
    },
    {
      "Country Name": "India",
      "Country Code": "in",
      "Priority Shipping Order Ships": 4,
      "Priority Shipping Arrives": 7,
      "Standard Shipping Order Ships": 4,
      "Standard Shipping Arrives": 9
    },
    {
      "Country Name": "Indonesia",
      "Country Code": "id",
      "Priority Shipping Order Ships": 4,
      "Priority Shipping Arrives": 7,
      "Standard Shipping Order Ships": 4,
      "Standard Shipping Arrives": 9
    },
    {
      "Country Name": "Iran (Islamic Republic of",
      "Country Code": "ir",
      "Priority Shipping Order Ships": 4,
      "Priority Shipping Arrives": 7,
      "Standard Shipping Order Ships": 4,
      "Standard Shipping Arrives": 9
    },
    {
      "Country Name": "Iraq",
      "Country Code": "iq",
      "Priority Shipping Order Ships": 4,
      "Priority Shipping Arrives": 7,
      "Standard Shipping Order Ships": 4,
      "Standard Shipping Arrives": 9
    },
    {
      "Country Name": "Ireland",
      "Country Code": "ie",
      "Priority Shipping Order Ships": 4,
      "Priority Shipping Arrives": 7,
      "Standard Shipping Order Ships": 4,
      "Standard Shipping Arrives": 9
    },
    {
      "Country Name": "Isle of Man",
      "Country Code": "im",
      "Priority Shipping Order Ships": 4,
      "Priority Shipping Arrives": 7,
      "Standard Shipping Order Ships": 4,
      "Standard Shipping Arrives": 9
    },
    {
      "Country Name": "Israel",
      "Country Code": "il",
      "Priority Shipping Order Ships": 4,
      "Priority Shipping Arrives": 7,
      "Standard Shipping Order Ships": 4,
      "Standard Shipping Arrives": 9
    },
    {
      "Country Name": "Italy",
      "Country Code": "it",
      "Priority Shipping Order Ships": 4,
      "Priority Shipping Arrives": 7,
      "Standard Shipping Order Ships": 4,
      "Standard Shipping Arrives": 9
    },
    {
      "Country Name": "Jamaica",
      "Country Code": "jm",
      "Priority Shipping Order Ships": 4,
      "Priority Shipping Arrives": 7,
      "Standard Shipping Order Ships": 4,
      "Standard Shipping Arrives": 9
    },
    {
      "Country Name": "Japan",
      "Country Code": "jp",
      "Priority Shipping Order Ships": 4,
      "Priority Shipping Arrives": 7,
      "Standard Shipping Order Ships": 4,
      "Standard Shipping Arrives": 9
    },
    {
      "Country Name": "Jersey",
      "Country Code": "je",
      "Priority Shipping Order Ships": 4,
      "Priority Shipping Arrives": 7,
      "Standard Shipping Order Ships": 4,
      "Standard Shipping Arrives": 9
    },
    {
      "Country Name": "Jordan",
      "Country Code": "jo",
      "Priority Shipping Order Ships": 4,
      "Priority Shipping Arrives": 7,
      "Standard Shipping Order Ships": 4,
      "Standard Shipping Arrives": 9
    },
    {
      "Country Name": "Kazakhstan",
      "Country Code": "kz",
      "Priority Shipping Order Ships": 4,
      "Priority Shipping Arrives": 7,
      "Standard Shipping Order Ships": 4,
      "Standard Shipping Arrives": 9
    },
    {
      "Country Name": "Kenya",
      "Country Code": "ke",
      "Priority Shipping Order Ships": 4,
      "Priority Shipping Arrives": 7,
      "Standard Shipping Order Ships": 4,
      "Standard Shipping Arrives": 9
    },
    {
      "Country Name": "Kiribati",
      "Country Code": "ki",
      "Priority Shipping Order Ships": 4,
      "Priority Shipping Arrives": 7,
      "Standard Shipping Order Ships": 4,
      "Standard Shipping Arrives": 9
    },
    {
      "Country Name": "Korea (Democratic People's Republic of)",
      "Country Code": "kp",
      "Priority Shipping Order Ships": 4,
      "Priority Shipping Arrives": 7,
      "Standard Shipping Order Ships": 4,
      "Standard Shipping Arrives": 9
    },
    {
      "Country Name": "Korea (Republic of)",
      "Country Code": "kr",
      "Priority Shipping Order Ships": 4,
      "Priority Shipping Arrives": 7,
      "Standard Shipping Order Ships": 4,
      "Standard Shipping Arrives": 9
    },
    {
      "Country Name": "Kuwait",
      "Country Code": "kw",
      "Priority Shipping Order Ships": 4,
      "Priority Shipping Arrives": 7,
      "Standard Shipping Order Ships": 4,
      "Standard Shipping Arrives": 9
    },
    {
      "Country Name": "Kyrgyzstan",
      "Country Code": "kg",
      "Priority Shipping Order Ships": 4,
      "Priority Shipping Arrives": 7,
      "Standard Shipping Order Ships": 4,
      "Standard Shipping Arrives": 9
    },
    {
      "Country Name": "Lao People's Democratic Republic",
      "Country Code": "la",
      "Priority Shipping Order Ships": 4,
      "Priority Shipping Arrives": 7,
      "Standard Shipping Order Ships": 4,
      "Standard Shipping Arrives": 9
    },
    {
      "Country Name": "Latvia",
      "Country Code": "lv",
      "Priority Shipping Order Ships": 4,
      "Priority Shipping Arrives": 7,
      "Standard Shipping Order Ships": 4,
      "Standard Shipping Arrives": 9
    },
    {
      "Country Name": "Lebanon",
      "Country Code": "lb",
      "Priority Shipping Order Ships": 4,
      "Priority Shipping Arrives": 7,
      "Standard Shipping Order Ships": 4,
      "Standard Shipping Arrives": 9
    },
    {
      "Country Name": "Lesotho",
      "Country Code": "ls",
      "Priority Shipping Order Ships": 4,
      "Priority Shipping Arrives": 7,
      "Standard Shipping Order Ships": 4,
      "Standard Shipping Arrives": 9
    },
    {
      "Country Name": "Liberia",
      "Country Code": "lr",
      "Priority Shipping Order Ships": 4,
      "Priority Shipping Arrives": 7,
      "Standard Shipping Order Ships": 4,
      "Standard Shipping Arrives": 9
    },
    {
      "Country Name": "Libya",
      "Country Code": "ly",
      "Priority Shipping Order Ships": 4,
      "Priority Shipping Arrives": 7,
      "Standard Shipping Order Ships": 4,
      "Standard Shipping Arrives": 9
    },
    {
      "Country Name": "Liechtenstein",
      "Country Code": "li",
      "Priority Shipping Order Ships": 4,
      "Priority Shipping Arrives": 7,
      "Standard Shipping Order Ships": 4,
      "Standard Shipping Arrives": 9
    },
    {
      "Country Name": "Lithuania",
      "Country Code": "lt",
      "Priority Shipping Order Ships": 4,
      "Priority Shipping Arrives": 7,
      "Standard Shipping Order Ships": 4,
      "Standard Shipping Arrives": 9
    },
    {
      "Country Name": "Luxembourg",
      "Country Code": "lu",
      "Priority Shipping Order Ships": 4,
      "Priority Shipping Arrives": 7,
      "Standard Shipping Order Ships": 4,
      "Standard Shipping Arrives": 9
    },
    {
      "Country Name": "Macao",
      "Country Code": "mo",
      "Priority Shipping Order Ships": 4,
      "Priority Shipping Arrives": 7,
      "Standard Shipping Order Ships": 4,
      "Standard Shipping Arrives": 9
    },
    {
      "Country Name": "Macedonia (the former Yugoslav Republic of)",
      "Country Code": "mk",
      "Priority Shipping Order Ships": 4,
      "Priority Shipping Arrives": 7,
      "Standard Shipping Order Ships": 4,
      "Standard Shipping Arrives": 9
    },
    {
      "Country Name": "Madagascar",
      "Country Code": "mg",
      "Priority Shipping Order Ships": 4,
      "Priority Shipping Arrives": 7,
      "Standard Shipping Order Ships": 4,
      "Standard Shipping Arrives": 9
    },
    {
      "Country Name": "Malawi",
      "Country Code": "mw",
      "Priority Shipping Order Ships": 4,
      "Priority Shipping Arrives": 7,
      "Standard Shipping Order Ships": 4,
      "Standard Shipping Arrives": 9
    },
    {
      "Country Name": "Malaysia",
      "Country Code": "my",
      "Priority Shipping Order Ships": 4,
      "Priority Shipping Arrives": 7,
      "Standard Shipping Order Ships": 4,
      "Standard Shipping Arrives": 9
    },
    {
      "Country Name": "Maldives",
      "Country Code": "mv",
      "Priority Shipping Order Ships": 4,
      "Priority Shipping Arrives": 7,
      "Standard Shipping Order Ships": 4,
      "Standard Shipping Arrives": 9
    },
    {
      "Country Name": "Mali",
      "Country Code": "ml",
      "Priority Shipping Order Ships": 4,
      "Priority Shipping Arrives": 7,
      "Standard Shipping Order Ships": 4,
      "Standard Shipping Arrives": 9
    },
    {
      "Country Name": "Malta",
      "Country Code": "mt",
      "Priority Shipping Order Ships": 4,
      "Priority Shipping Arrives": 7,
      "Standard Shipping Order Ships": 4,
      "Standard Shipping Arrives": 9
    },
    {
      "Country Name": "Marshall islands",
      "Country Code": "mh",
      "Priority Shipping Order Ships": 4,
      "Priority Shipping Arrives": 7,
      "Standard Shipping Order Ships": 4,
      "Standard Shipping Arrives": 9
    },
    {
      "Country Name": "Martinique",
      "Country Code": "mq",
      "Priority Shipping Order Ships": 4,
      "Priority Shipping Arrives": 7,
      "Standard Shipping Order Ships": 4,
      "Standard Shipping Arrives": 9
    },
    {
      "Country Name": "Mauritania",
      "Country Code": "mr",
      "Priority Shipping Order Ships": 4,
      "Priority Shipping Arrives": 7,
      "Standard Shipping Order Ships": 4,
      "Standard Shipping Arrives": 9
    },
    {
      "Country Name": "Mauritius",
      "Country Code": "mu",
      "Priority Shipping Order Ships": 4,
      "Priority Shipping Arrives": 7,
      "Standard Shipping Order Ships": 4,
      "Standard Shipping Arrives": 9
    },
    {
      "Country Name": "Mayotte",
      "Country Code": "yt",
      "Priority Shipping Order Ships": 4,
      "Priority Shipping Arrives": 7,
      "Standard Shipping Order Ships": 4,
      "Standard Shipping Arrives": 9
    },
    {
      "Country Name": "Mexico",
      "Country Code": "mx",
      "Priority Shipping Order Ships": 4,
      "Priority Shipping Arrives": 7,
      "Standard Shipping Order Ships": 4,
      "Standard Shipping Arrives": 9
    },
    {
      "Country Name": "Micronesia (Federated States of)",
      "Country Code": "fm",
      "Priority Shipping Order Ships": 4,
      "Priority Shipping Arrives": 7,
      "Standard Shipping Order Ships": 4,
      "Standard Shipping Arrives": 9
    },
    {
      "Country Name": "Moldova (Republic of)",
      "Country Code": "md",
      "Priority Shipping Order Ships": 4,
      "Priority Shipping Arrives": 7,
      "Standard Shipping Order Ships": 4,
      "Standard Shipping Arrives": 9
    },
    {
      "Country Name": "Monaco",
      "Country Code": "mc",
      "Priority Shipping Order Ships": 4,
      "Priority Shipping Arrives": 7,
      "Standard Shipping Order Ships": 4,
      "Standard Shipping Arrives": 9
    },
    {
      "Country Name": "Mongolia",
      "Country Code": "mn",
      "Priority Shipping Order Ships": 4,
      "Priority Shipping Arrives": 7,
      "Standard Shipping Order Ships": 4,
      "Standard Shipping Arrives": 9
    },
    {
      "Country Name": "Montenegro",
      "Country Code": "me",
      "Priority Shipping Order Ships": 4,
      "Priority Shipping Arrives": 7,
      "Standard Shipping Order Ships": 4,
      "Standard Shipping Arrives": 9
    },
    {
      "Country Name": "Montserrat",
      "Country Code": "ms",
      "Priority Shipping Order Ships": 4,
      "Priority Shipping Arrives": 7,
      "Standard Shipping Order Ships": 4,
      "Standard Shipping Arrives": 9
    },
    {
      "Country Name": "Morocco",
      "Country Code": "ma",
      "Priority Shipping Order Ships": 4,
      "Priority Shipping Arrives": 7,
      "Standard Shipping Order Ships": 4,
      "Standard Shipping Arrives": 9
    },
    {
      "Country Name": "Mozambique",
      "Country Code": "mz",
      "Priority Shipping Order Ships": 4,
      "Priority Shipping Arrives": 7,
      "Standard Shipping Order Ships": 4,
      "Standard Shipping Arrives": 9
    },
    {
      "Country Name": "Myanmar",
      "Country Code": "mm",
      "Priority Shipping Order Ships": 4,
      "Priority Shipping Arrives": 7,
      "Standard Shipping Order Ships": 4,
      "Standard Shipping Arrives": 9
    },
    {
      "Country Name": "Namibia",
      "Country Code": "na",
      "Priority Shipping Order Ships": 4,
      "Priority Shipping Arrives": 7,
      "Standard Shipping Order Ships": 4,
      "Standard Shipping Arrives": 9
    },
    {
      "Country Name": "Nauru",
      "Country Code": "nr",
      "Priority Shipping Order Ships": 4,
      "Priority Shipping Arrives": 7,
      "Standard Shipping Order Ships": 4,
      "Standard Shipping Arrives": 9
    },
    {
      "Country Name": "Nepal",
      "Country Code": "np",
      "Priority Shipping Order Ships": 4,
      "Priority Shipping Arrives": 7,
      "Standard Shipping Order Ships": 4,
      "Standard Shipping Arrives": 9
    },
    {
      "Country Name": "Netherlands",
      "Country Code": "nl",
      "Priority Shipping Order Ships": 4,
      "Priority Shipping Arrives": 7,
      "Standard Shipping Order Ships": 4,
      "Standard Shipping Arrives": 9
    },
    {
      "Country Name": "New Caledonia",
      "Country Code": "nc",
      "Priority Shipping Order Ships": 4,
      "Priority Shipping Arrives": 7,
      "Standard Shipping Order Ships": 4,
      "Standard Shipping Arrives": 9
    },
    {
      "Country Name": "New Zealand",
      "Country Code": "nz",
      "Priority Shipping Order Ships": 4,
      "Priority Shipping Arrives": 7,
      "Standard Shipping Order Ships": 4,
      "Standard Shipping Arrives": 9
    },
    {
      "Country Name": "Nicaragua",
      "Country Code": "ni",
      "Priority Shipping Order Ships": 4,
      "Priority Shipping Arrives": 7,
      "Standard Shipping Order Ships": 4,
      "Standard Shipping Arrives": 9
    },
    {
      "Country Name": "Niger",
      "Country Code": "ne",
      "Priority Shipping Order Ships": 4,
      "Priority Shipping Arrives": 7,
      "Standard Shipping Order Ships": 4,
      "Standard Shipping Arrives": 9
    },
    {
      "Country Name": "Nigeria",
      "Country Code": "ng",
      "Priority Shipping Order Ships": 4,
      "Priority Shipping Arrives": 7,
      "Standard Shipping Order Ships": 4,
      "Standard Shipping Arrives": 9
    },
    {
      "Country Name": "Niue",
      "Country Code": "nu",
      "Priority Shipping Order Ships": 4,
      "Priority Shipping Arrives": 7,
      "Standard Shipping Order Ships": 4,
      "Standard Shipping Arrives": 9
    },
    {
      "Country Name": "Norfolk Island",
      "Country Code": "nf",
      "Priority Shipping Order Ships": 4,
      "Priority Shipping Arrives": 7,
      "Standard Shipping Order Ships": 4,
      "Standard Shipping Arrives": 9
    },
    {
      "Country Name": "Northern Mariana Islands",
      "Country Code": "mp",
      "Priority Shipping Order Ships": 4,
      "Priority Shipping Arrives": 7,
      "Standard Shipping Order Ships": 4,
      "Standard Shipping Arrives": 9
    },
    {
      "Country Name": "Norway",
      "Country Code": "no",
      "Priority Shipping Order Ships": 4,
      "Priority Shipping Arrives": 7,
      "Standard Shipping Order Ships": 4,
      "Standard Shipping Arrives": 9
    },
    {
      "Country Name": "Oman",
      "Country Code": "om",
      "Priority Shipping Order Ships": 4,
      "Priority Shipping Arrives": 7,
      "Standard Shipping Order Ships": 4,
      "Standard Shipping Arrives": 9
    },
    {
      "Country Name": "Pakistan",
      "Country Code": "pk",
      "Priority Shipping Order Ships": 4,
      "Priority Shipping Arrives": 7,
      "Standard Shipping Order Ships": 4,
      "Standard Shipping Arrives": 9
    },
    {
      "Country Name": "Palau",
      "Country Code": "pw",
      "Priority Shipping Order Ships": 4,
      "Priority Shipping Arrives": 7,
      "Standard Shipping Order Ships": 4,
      "Standard Shipping Arrives": 9
    },
    {
      "Country Name": "Palestine, State of",
      "Country Code": "ps",
      "Priority Shipping Order Ships": 4,
      "Priority Shipping Arrives": 7,
      "Standard Shipping Order Ships": 4,
      "Standard Shipping Arrives": 9
    },
    {
      "Country Name": "Panama",
      "Country Code": "pa",
      "Priority Shipping Order Ships": 4,
      "Priority Shipping Arrives": 7,
      "Standard Shipping Order Ships": 4,
      "Standard Shipping Arrives": 9
    },
    {
      "Country Name": "Papua New Guinea",
      "Country Code": "pg",
      "Priority Shipping Order Ships": 4,
      "Priority Shipping Arrives": 7,
      "Standard Shipping Order Ships": 4,
      "Standard Shipping Arrives": 9
    },
    {
      "Country Name": "Paraguay",
      "Country Code": "py",
      "Priority Shipping Order Ships": 4,
      "Priority Shipping Arrives": 7,
      "Standard Shipping Order Ships": 4,
      "Standard Shipping Arrives": 9
    },
    {
      "Country Name": "Peru",
      "Country Code": "pe",
      "Priority Shipping Order Ships": 4,
      "Priority Shipping Arrives": 7,
      "Standard Shipping Order Ships": 4,
      "Standard Shipping Arrives": 9
    },
    {
      "Country Name": "Philippines",
      "Country Code": "ph",
      "Priority Shipping Order Ships": 4,
      "Priority Shipping Arrives": 7,
      "Standard Shipping Order Ships": 4,
      "Standard Shipping Arrives": 9
    },
    {
      "Country Name": "Pitcairn",
      "Country Code": "pn",
      "Priority Shipping Order Ships": 4,
      "Priority Shipping Arrives": 7,
      "Standard Shipping Order Ships": 4,
      "Standard Shipping Arrives": 9
    },
    {
      "Country Name": "Poland",
      "Country Code": "pl",
      "Priority Shipping Order Ships": 4,
      "Priority Shipping Arrives": 7,
      "Standard Shipping Order Ships": 4,
      "Standard Shipping Arrives": 9
    },
    {
      "Country Name": "Portugal",
      "Country Code": "pt",
      "Priority Shipping Order Ships": 4,
      "Priority Shipping Arrives": 7,
      "Standard Shipping Order Ships": 4,
      "Standard Shipping Arrives": 9
    },
    {
      "Country Name": "Puerto Rico",
      "Country Code": "pr",
      "Priority Shipping Order Ships": 4,
      "Priority Shipping Arrives": 7,
      "Standard Shipping Order Ships": 4,
      "Standard Shipping Arrives": 9
    },
    {
      "Country Name": "Qatar",
      "Country Code": "qa",
      "Priority Shipping Order Ships": 4,
      "Priority Shipping Arrives": 7,
      "Standard Shipping Order Ships": 4,
      "Standard Shipping Arrives": 9
    },
    {
      "Country Name": "Republic of Kosovo",
      "Country Code": "xk",
      "Priority Shipping Order Ships": 4,
      "Priority Shipping Arrives": 7,
      "Standard Shipping Order Ships": 4,
      "Standard Shipping Arrives": 9
    },
    {
      "Country Name": "Romania",
      "Country Code": "ro",
      "Priority Shipping Order Ships": 4,
      "Priority Shipping Arrives": 7,
      "Standard Shipping Order Ships": 4,
      "Standard Shipping Arrives": 9
    },
    {
      "Country Name": "Russian Federation",
      "Country Code": "ru",
      "Priority Shipping Order Ships": 4,
      "Priority Shipping Arrives": 7,
      "Standard Shipping Order Ships": 4,
      "Standard Shipping Arrives": 9
    },
    {
      "Country Name": "Rwanda",
      "Country Code": "rw",
      "Priority Shipping Order Ships": 4,
      "Priority Shipping Arrives": 7,
      "Standard Shipping Order Ships": 4,
      "Standard Shipping Arrives": 9
    },
    {
      "Country Name": "Réunion",
      "Country Code": "re",
      "Priority Shipping Order Ships": 4,
      "Priority Shipping Arrives": 7,
      "Standard Shipping Order Ships": 4,
      "Standard Shipping Arrives": 9
    },
    {
      "Country Name": "Saint Barthélemy",
      "Country Code": "bl",
      "Priority Shipping Order Ships": 4,
      "Priority Shipping Arrives": 7,
      "Standard Shipping Order Ships": 4,
      "Standard Shipping Arrives": 9
    },
    {
      "Country Name": "Saint Helena, Ascension and Tristan da Cunha",
      "Country Code": "sh",
      "Priority Shipping Order Ships": 4,
      "Priority Shipping Arrives": 7,
      "Standard Shipping Order Ships": 4,
      "Standard Shipping Arrives": 9
    },
    {
      "Country Name": "Saint Kitts and Nevis",
      "Country Code": "kn",
      "Priority Shipping Order Ships": 4,
      "Priority Shipping Arrives": 7,
      "Standard Shipping Order Ships": 4,
      "Standard Shipping Arrives": 9
    },
    {
      "Country Name": "Saint Lucia",
      "Country Code": "lc",
      "Priority Shipping Order Ships": 4,
      "Priority Shipping Arrives": 7,
      "Standard Shipping Order Ships": 4,
      "Standard Shipping Arrives": 9
    },
    {
      "Country Name": "Saint Martin (French part)",
      "Country Code": "mf",
      "Priority Shipping Order Ships": 4,
      "Priority Shipping Arrives": 7,
      "Standard Shipping Order Ships": 4,
      "Standard Shipping Arrives": 9
    },
    {
      "Country Name": "Saint Pierre and Miquelon",
      "Country Code": "pm",
      "Priority Shipping Order Ships": 4,
      "Priority Shipping Arrives": 7,
      "Standard Shipping Order Ships": 4,
      "Standard Shipping Arrives": 9
    },
    {
      "Country Name": "Saint Vincent and the Grenadines",
      "Country Code": "vc",
      "Priority Shipping Order Ships": 4,
      "Priority Shipping Arrives": 7,
      "Standard Shipping Order Ships": 4,
      "Standard Shipping Arrives": 9
    },
    {
      "Country Name": "Samoa",
      "Country Code": "ws",
      "Priority Shipping Order Ships": 4,
      "Priority Shipping Arrives": 7,
      "Standard Shipping Order Ships": 4,
      "Standard Shipping Arrives": 9
    },
    {
      "Country Name": "San Marino",
      "Country Code": "sm",
      "Priority Shipping Order Ships": 4,
      "Priority Shipping Arrives": 7,
      "Standard Shipping Order Ships": 4,
      "Standard Shipping Arrives": 9
    },
    {
      "Country Name": "Sao Tome and Principe",
      "Country Code": "st",
      "Priority Shipping Order Ships": 4,
      "Priority Shipping Arrives": 7,
      "Standard Shipping Order Ships": 4,
      "Standard Shipping Arrives": 9
    },
    {
      "Country Name": "Saudi Arabia",
      "Country Code": "sa",
      "Priority Shipping Order Ships": 4,
      "Priority Shipping Arrives": 7,
      "Standard Shipping Order Ships": 4,
      "Standard Shipping Arrives": 9
    },
    {
      "Country Name": "Senegal",
      "Country Code": "sn",
      "Priority Shipping Order Ships": 4,
      "Priority Shipping Arrives": 7,
      "Standard Shipping Order Ships": 4,
      "Standard Shipping Arrives": 9
    },
    {
      "Country Name": "Serbia",
      "Country Code": "rs",
      "Priority Shipping Order Ships": 4,
      "Priority Shipping Arrives": 7,
      "Standard Shipping Order Ships": 4,
      "Standard Shipping Arrives": 9
    },
    {
      "Country Name": "Seychelles",
      "Country Code": "sc",
      "Priority Shipping Order Ships": 4,
      "Priority Shipping Arrives": 7,
      "Standard Shipping Order Ships": 4,
      "Standard Shipping Arrives": 9
    },
    {
      "Country Name": "Sierra Leone",
      "Country Code": "sl",
      "Priority Shipping Order Ships": 4,
      "Priority Shipping Arrives": 7,
      "Standard Shipping Order Ships": 4,
      "Standard Shipping Arrives": 9
    },
    {
      "Country Name": "Singapore",
      "Country Code": "sg",
      "Priority Shipping Order Ships": 4,
      "Priority Shipping Arrives": 7,
      "Standard Shipping Order Ships": 4,
      "Standard Shipping Arrives": 9
    },
    {
      "Country Name": "Sint Maarten (Dutch part)",
      "Country Code": "sx",
      "Priority Shipping Order Ships": 4,
      "Priority Shipping Arrives": 7,
      "Standard Shipping Order Ships": 4,
      "Standard Shipping Arrives": 9
    },
    {
      "Country Name": "Slovakia",
      "Country Code": "sk",
      "Priority Shipping Order Ships": 4,
      "Priority Shipping Arrives": 7,
      "Standard Shipping Order Ships": 4,
      "Standard Shipping Arrives": 9
    },
    {
      "Country Name": "Slovenia",
      "Country Code": "si",
      "Priority Shipping Order Ships": 4,
      "Priority Shipping Arrives": 7,
      "Standard Shipping Order Ships": 4,
      "Standard Shipping Arrives": 9
    },
    {
      "Country Name": "Solomon Islands",
      "Country Code": "sb",
      "Priority Shipping Order Ships": 4,
      "Priority Shipping Arrives": 7,
      "Standard Shipping Order Ships": 4,
      "Standard Shipping Arrives": 9
    },
    {
      "Country Name": "Somalia",
      "Country Code": "so",
      "Priority Shipping Order Ships": 4,
      "Priority Shipping Arrives": 7,
      "Standard Shipping Order Ships": 4,
      "Standard Shipping Arrives": 9
    },
    {
      "Country Name": "South Africa",
      "Country Code": "za",
      "Priority Shipping Order Ships": 4,
      "Priority Shipping Arrives": 7,
      "Standard Shipping Order Ships": 4,
      "Standard Shipping Arrives": 9
    },
    {
      "Country Name": "South Georgia and the South Sandwich Islands",
      "Country Code": "gs",
      "Priority Shipping Order Ships": 4,
      "Priority Shipping Arrives": 7,
      "Standard Shipping Order Ships": 4,
      "Standard Shipping Arrives": 9
    },
    {
      "Country Name": "South Sudan",
      "Country Code": "ss",
      "Priority Shipping Order Ships": 4,
      "Priority Shipping Arrives": 7,
      "Standard Shipping Order Ships": 4,
      "Standard Shipping Arrives": 9
    },
    {
      "Country Name": "Spain",
      "Country Code": "es",
      "Priority Shipping Order Ships": 4,
      "Priority Shipping Arrives": 7,
      "Standard Shipping Order Ships": 4,
      "Standard Shipping Arrives": 9
    },
    {
      "Country Name": "Sri Lanka",
      "Country Code": "lk",
      "Priority Shipping Order Ships": 4,
      "Priority Shipping Arrives": 7,
      "Standard Shipping Order Ships": 4,
      "Standard Shipping Arrives": 9
    },
    {
      "Country Name": "Sudan",
      "Country Code": "sd",
      "Priority Shipping Order Ships": 4,
      "Priority Shipping Arrives": 7,
      "Standard Shipping Order Ships": 4,
      "Standard Shipping Arrives": 9
    },
    {
      "Country Name": "Suriname",
      "Country Code": "sr",
      "Priority Shipping Order Ships": 4,
      "Priority Shipping Arrives": 7,
      "Standard Shipping Order Ships": 4,
      "Standard Shipping Arrives": 9
    },
    {
      "Country Name": "Svalbard and Jan Mayen",
      "Country Code": "sj",
      "Priority Shipping Order Ships": 4,
      "Priority Shipping Arrives": 7,
      "Standard Shipping Order Ships": 4,
      "Standard Shipping Arrives": 9
    },
    {
      "Country Name": "Swaziland",
      "Country Code": "sz",
      "Priority Shipping Order Ships": 4,
      "Priority Shipping Arrives": 7,
      "Standard Shipping Order Ships": 4,
      "Standard Shipping Arrives": 9
    },
    {
      "Country Name": "Sweden",
      "Country Code": "se",
      "Priority Shipping Order Ships": 4,
      "Priority Shipping Arrives": 7,
      "Standard Shipping Order Ships": 4,
      "Standard Shipping Arrives": 9
    },
    {
      "Country Name": "Switzerland",
      "Country Code": "ch",
      "Priority Shipping Order Ships": 4,
      "Priority Shipping Arrives": 7,
      "Standard Shipping Order Ships": 4,
      "Standard Shipping Arrives": 9
    },
    {
      "Country Name": "Syrian Arab Republic",
      "Country Code": "sy",
      "Priority Shipping Order Ships": 4,
      "Priority Shipping Arrives": 7,
      "Standard Shipping Order Ships": 4,
      "Standard Shipping Arrives": 9
    },
    {
      "Country Name": "Taiwan",
      "Country Code": "tw",
      "Priority Shipping Order Ships": 4,
      "Priority Shipping Arrives": 7,
      "Standard Shipping Order Ships": 4,
      "Standard Shipping Arrives": 9
    },
    {
      "Country Name": "Tajikistan",
      "Country Code": "tj",
      "Priority Shipping Order Ships": 4,
      "Priority Shipping Arrives": 7,
      "Standard Shipping Order Ships": 4,
      "Standard Shipping Arrives": 9
    },
    {
      "Country Name": "Tanzania",
      "Country Code": "tz",
      "Priority Shipping Order Ships": 4,
      "Priority Shipping Arrives": 7,
      "Standard Shipping Order Ships": 4,
      "Standard Shipping Arrives": 9
    },
    {
      "Country Name": "Thailand",
      "Country Code": "th",
      "Priority Shipping Order Ships": 4,
      "Priority Shipping Arrives": 7,
      "Standard Shipping Order Ships": 4,
      "Standard Shipping Arrives": 9
    },
    {
      "Country Name": "Timor-Leste",
      "Country Code": "tl",
      "Priority Shipping Order Ships": 4,
      "Priority Shipping Arrives": 7,
      "Standard Shipping Order Ships": 4,
      "Standard Shipping Arrives": 9
    },
    {
      "Country Name": "Togo",
      "Country Code": "tg",
      "Priority Shipping Order Ships": 4,
      "Priority Shipping Arrives": 7,
      "Standard Shipping Order Ships": 4,
      "Standard Shipping Arrives": 9
    },
    {
      "Country Name": "Tokelau",
      "Country Code": "tk",
      "Priority Shipping Order Ships": 4,
      "Priority Shipping Arrives": 7,
      "Standard Shipping Order Ships": 4,
      "Standard Shipping Arrives": 9
    },
    {
      "Country Name": "Tonga",
      "Country Code": "to",
      "Priority Shipping Order Ships": 4,
      "Priority Shipping Arrives": 7,
      "Standard Shipping Order Ships": 4,
      "Standard Shipping Arrives": 9
    },
    {
      "Country Name": "Trinidad and Tobago",
      "Country Code": "tt",
      "Priority Shipping Order Ships": 4,
      "Priority Shipping Arrives": 7,
      "Standard Shipping Order Ships": 4,
      "Standard Shipping Arrives": 9
    },
    {
      "Country Name": "Tunisia",
      "Country Code": "tn",
      "Priority Shipping Order Ships": 4,
      "Priority Shipping Arrives": 7,
      "Standard Shipping Order Ships": 4,
      "Standard Shipping Arrives": 9
    },
    {
      "Country Name": "Turkey",
      "Country Code": "tr",
      "Priority Shipping Order Ships": 4,
      "Priority Shipping Arrives": 7,
      "Standard Shipping Order Ships": 4,
      "Standard Shipping Arrives": 9
    },
    {
      "Country Name": "Turkmenistan",
      "Country Code": "tm",
      "Priority Shipping Order Ships": 4,
      "Priority Shipping Arrives": 7,
      "Standard Shipping Order Ships": 4,
      "Standard Shipping Arrives": 9
    },
    {
      "Country Name": "Turks and Caicos Islands",
      "Country Code": "tc",
      "Priority Shipping Order Ships": 4,
      "Priority Shipping Arrives": 7,
      "Standard Shipping Order Ships": 4,
      "Standard Shipping Arrives": 9
    },
    {
      "Country Name": "Tuvalu",
      "Country Code": "tv",
      "Priority Shipping Order Ships": 4,
      "Priority Shipping Arrives": 7,
      "Standard Shipping Order Ships": 4,
      "Standard Shipping Arrives": 9
    },
    {
      "Country Name": "Uganda",
      "Country Code": "ug",
      "Priority Shipping Order Ships": 4,
      "Priority Shipping Arrives": 7,
      "Standard Shipping Order Ships": 4,
      "Standard Shipping Arrives": 9
    },
    {
      "Country Name": "Ukraine",
      "Country Code": "ua",
      "Priority Shipping Order Ships": 4,
      "Priority Shipping Arrives": 7,
      "Standard Shipping Order Ships": 4,
      "Standard Shipping Arrives": 9
    },
    {
      "Country Name": "United Arab Emirates",
      "Country Code": "ae",
      "Priority Shipping Order Ships": 4,
      "Priority Shipping Arrives": 7,
      "Standard Shipping Order Ships": 4,
      "Standard Shipping Arrives": 9
    },
    {
      "Country Name": "United Kingdom of Great Britain and Northern Ireland",
      "Country Code": "gb",
      "Priority Shipping Order Ships": 4,
      "Priority Shipping Arrives": 7,
      "Standard Shipping Order Ships": 4,
      "Standard Shipping Arrives": 9
    },
    {
      "Country Name": "United States Minor Outlying Islands",
      "Country Code": "um",
      "Priority Shipping Order Ships": 4,
      "Priority Shipping Arrives": 7,
      "Standard Shipping Order Ships": 4,
      "Standard Shipping Arrives": 9
    },
    {
      "Country Name": "United States",
      "Country Code": "us",
      "Priority Shipping Order Ships": 4,
      "Priority Shipping Arrives": 7,
      "Standard Shipping Order Ships": 4,
      "Standard Shipping Arrives": 9
    },
    {
      "Country Name": "Uruguay",
      "Country Code": "uy",
      "Priority Shipping Order Ships": 4,
      "Priority Shipping Arrives": 7,
      "Standard Shipping Order Ships": 4,
      "Standard Shipping Arrives": 9
    },
    {
      "Country Name": "Uzbekistan",
      "Country Code": "uz",
      "Priority Shipping Order Ships": 4,
      "Priority Shipping Arrives": 7,
      "Standard Shipping Order Ships": 4,
      "Standard Shipping Arrives": 9
    },
    {
      "Country Name": "Vanuatu",
      "Country Code": "vu",
      "Priority Shipping Order Ships": 4,
      "Priority Shipping Arrives": 7,
      "Standard Shipping Order Ships": 4,
      "Standard Shipping Arrives": 9
    },
    {
      "Country Name": "Venezuela (Bolivarian Republic of)",
      "Country Code": "ve",
      "Priority Shipping Order Ships": 4,
      "Priority Shipping Arrives": 7,
      "Standard Shipping Order Ships": 4,
      "Standard Shipping Arrives": 9
    },
    {
      "Country Name": "Viet Nam",
      "Country Code": "vn",
      "Priority Shipping Order Ships": 4,
      "Priority Shipping Arrives": 7,
      "Standard Shipping Order Ships": 4,
      "Standard Shipping Arrives": 9
    },
    {
      "Country Name": "Virgin Islands (British)",
      "Country Code": "vg",
      "Priority Shipping Order Ships": 4,
      "Priority Shipping Arrives": 7,
      "Standard Shipping Order Ships": 4,
      "Standard Shipping Arrives": 9
    },
    {
      "Country Name": "Virgin Islands (U.S.)",
      "Country Code": "vi",
      "Priority Shipping Order Ships": 4,
      "Priority Shipping Arrives": 7,
      "Standard Shipping Order Ships": 4,
      "Standard Shipping Arrives": 9
    },
    {
      "Country Name": "Wallis and Futuna",
      "Country Code": "wf",
      "Priority Shipping Order Ships": 4,
      "Priority Shipping Arrives": 7,
      "Standard Shipping Order Ships": 4,
      "Standard Shipping Arrives": 9
    },
    {
      "Country Name": "Western Sahara",
      "Country Code": "eh",
      "Priority Shipping Order Ships": 4,
      "Priority Shipping Arrives": 7,
      "Standard Shipping Order Ships": 4,
      "Standard Shipping Arrives": 9
    },
    {
      "Country Name": "Yemen",
      "Country Code": "ye",
      "Priority Shipping Order Ships": 4,
      "Priority Shipping Arrives": 7,
      "Standard Shipping Order Ships": 4,
      "Standard Shipping Arrives": 9
    },
    {
      "Country Name": "Zambia",
      "Country Code": "zm",
      "Priority Shipping Order Ships": 4,
      "Priority Shipping Arrives": 7,
      "Standard Shipping Order Ships": 4,
      "Standard Shipping Arrives": 9
    },
    {
      "Country Name": "Zimbabwe",
      "Country Code": "zw",
      "Priority Shipping Order Ships": 4,
      "Priority Shipping Arrives": 7,
      "Standard Shipping Order Ships": 4,
      "Standard Shipping Arrives": 9
    },
    {
      "Country Name": "",
      "Country Code": "",
      "Priority Shipping Order Ships": "",
      "Priority Shipping Arrives": "",
      "Standard Shipping Order Ships": "",
      "Standard Shipping Arrives": ""
    }
  ]
};

class DeliveryDateComponent {
  constructor() {
    this.apiUrl =
      "https://script.google.com/macros/s/AKfycbzS9kluIsIgCFOoAhsLmDcAlYTsXadCxIF2CYtsrmM7fua5WwLul14vGWmrncicdpQg/exec";
    this.countries = [];
    this.filteredCountries = [];
    this.selectedCountry = null;
    this.isLoading = false;
    this.language = "en"; // Force English only
    this.currentOffsets = null; // overrides from clicked item datasets

    // DOM elements
    this.elements = {
      modal: null,
      list: null,
      searchInput: null,
      openButton: null,
      closeButton: null,
      currentCountryButton: null,
      currentCountryFlag: null,
      priorityTrigger: null,
      standardTrigger: null,
      priorityModal: null,
      standardModal: null,
    };

    this.init();
  }
  getPreferredLanguage() {
    try {
      const langs = (
        navigator.languages && navigator.languages.length
          ? navigator.languages
          : [navigator.language || navigator.userLanguage]
      ).filter(Boolean);
      if (!langs || langs.length === 0) return "en";
      // normalize to two-letter code where possible
      const primary = langs[0].toLowerCase();
      const match = primary.match(/^[a-z]{2}/);
      return match ? match[0] : "en";
    } catch (_) {
      return "en";
    }
  }

  // =====================
  // Shipping date helpers
  // =====================
  parseDaysRange(value) {
    if (value == null) return { min: 0, max: 0 };
    let str = String(value).toLowerCase().trim();
    if (str === "") return { min: 0, max: 0 };
    // Normalize common separators and words
    str = str
      .replace(/[–—~to]+/g, "-") // en/em dash, tilde, 'to'
      .replace(/[^0-9\- ]+/g, " "); // strip non-numeric/separator
    const nums = (str.match(/\d+/g) || []).map((n) => parseInt(n, 10));
    if (nums.length === 1) {
      return { min: nums[0], max: nums[0] };
    }
    if (nums.length >= 2) {
      const a = nums[0];
      const b = nums[1];
      return { min: Math.min(a, b), max: Math.max(a, b) };
    }
    return { min: 0, max: 0 };
  }

  addDays(date, days) {
    const d = new Date(date.getFullYear(), date.getMonth(), date.getDate());
    d.setHours(12, 0, 0, 0); // midday to avoid DST jumps
    d.setDate(d.getDate() + days);
    return d;
  }

  formatMonthDay(d) {
    return d.toLocaleDateString("en-US", { month: "short", day: "numeric" });
  }

  formatRange(start, end) {
    const sameDay =
      start.getFullYear() === end.getFullYear() &&
      start.getMonth() === end.getMonth() &&
      start.getDate() === end.getDate();
    if (sameDay) return this.formatMonthDay(start);
    const sameMonth =
      start.getFullYear() === end.getFullYear() &&
      start.getMonth() === end.getMonth();
    if (sameMonth) {
      const month = start.toLocaleDateString("en-US", { month: "short" });
      return `${month} ${start.getDate()} – ${end.getDate()}`;
    }
    return `${this.formatMonthDay(start)} – ${this.formatMonthDay(end)}`;
  }

  getCountryBySelected() {
    if (!this.selectedCountry || !this.selectedCountry.code) return null;
    const code = this.selectedCountry.code.toUpperCase();
    return this.countries.find(
      (c) => String(c["Country Code"] || c.code || "").toUpperCase() === code
    );
  }

  computeShipping(type) {
    const data = this.getCountryBySelected();
    if (!data) return null;
    const today = new Date();
    // Prefer overrides from a clicked country button if available
    const shipSrc =
      type === "priority"
        ? (this.currentOffsets && this.currentOffsets.priorityOrderShips) ||
          data["Priority Shipping Order Ships"]
        : (this.currentOffsets && this.currentOffsets.standardOrderShips) ||
          data["Standard Shipping Order Ships"];
    const arriveSrc =
      type === "priority"
        ? (this.currentOffsets && this.currentOffsets.priorityArrives) ||
          data["Priority Shipping Arrives"]
        : (this.currentOffsets && this.currentOffsets.standardArrives) ||
          data["Standard Shipping Arrives"];

    const shipDays = this.parseDaysRange(shipSrc);
    const arriveDays = this.parseDaysRange(arriveSrc);

    // Inclusive day-to-day ranges (e.g., Oct 31–Nov 1, Nov 3–5)
    const shipStart = this.addDays(today, Math.max(0, shipDays.min));
    let shipEnd = this.addDays(today, Math.max(0, shipDays.max));
    // Ensure Order Ships displays as a range when min==max
    if (
      shipStart.getFullYear() === shipEnd.getFullYear() &&
      shipStart.getMonth() === shipEnd.getMonth() &&
      shipStart.getDate() === shipEnd.getDate()
    ) {
      // day-to-day is 2 for Order Ships → extend by 2 days
      shipEnd = this.addDays(shipEnd, 2);
    }

    let arriveStart = this.addDays(shipStart, Math.max(0, arriveDays.min));
    let arriveEnd = this.addDays(shipEnd, Math.max(0, arriveDays.max));
    // Force a day-to-day display when range collapses to a single day
    // arriveEnd = this.addDays(arriveEnd, 1);
    if (
      arriveStart.getFullYear() === arriveEnd.getFullYear() &&
      arriveStart.getMonth() === arriveEnd.getMonth() &&
      arriveStart.getDate() === arriveEnd.getDate()
    ) {
      // day-to-day is 4 for Arrives → extend by 3 days (inclusive span of 4)
      arriveEnd = this.addDays(arriveEnd, 3);
    }

    if (type === "standard") {
      arriveEnd = this.addDays(arriveEnd, 1);
    }

    return {
      placed: today,
      shipStart,
      shipEnd,
      arriveStart,
      arriveEnd,
      arriveLabel: this.formatRange(arriveStart, arriveEnd),
      shipLabel: this.formatRange(shipStart, shipEnd),
      placedLabel: this.formatMonthDay(today),
    };
  }

  updateArrivalTriggers() {
    const priority = this.computeShipping("priority");
    const standard = this.computeShipping("standard");
    if (this.elements.priorityTrigger && priority) {
      this.elements.priorityTrigger.textContent = priority.arriveLabel;
      this.elements.priorityTrigger.dataset.delivery = priority.arriveLabel;
    }
    if (this.elements.standardTrigger && standard) {
      this.elements.standardTrigger.textContent = standard.arriveLabel;
      this.elements.standardTrigger.dataset.delivery = standard.arriveLabel;
    }
  }

  updateAndShowShippingModal(type) {
    const result = this.computeShipping(type);
    if (!result) return;
    const modal =
      type === "priority"
        ? this.elements.priorityModal
        : this.elements.standardModal;
    if (!modal) return;

    const placedEl = modal.querySelector("#order-placed-date");
    const shipEl = modal.querySelector("#order-ship-date");
    const arriveEl = modal.querySelector("#arrives-date");
    if (placedEl) placedEl.textContent = result.placedLabel;
    if (shipEl) shipEl.textContent = result.shipLabel;
    if (arriveEl) arriveEl.textContent = result.arriveLabel;

    modal.classList.add("show");
  }
  getCountryDisplayName(country) {
    // English-only display (no translations)
    return (
      (country &&
        (country["Country Name"] || country.country_name || country.name)) ||
      ""
    );
  }

  init() {
    this.bindElements();
    this.bindEvents();
    this.loadCountries();
  }

  bindElements() {
    this.elements.modal = document.querySelector(".delivery-widget__modal");
    this.elements.list = document.querySelector(".delivery-widget__list");
    this.elements.searchInput = document.querySelector(
      ".delivery-widget__search input"
    );
    this.elements.openButton = document.querySelector(
      ".js-delivery-widget-button"
    );
    this.elements.currentCountryButton = document.querySelector(
      ".js-delivery-widget-button"
    );
    this.elements.currentCountryFlag = document.querySelector(
      ".js-current-country-flag"
    );
    this.elements.priorityTrigger = document.querySelector(
      ".js-priority-shipping-modal-trigger"
    );
    this.elements.standardTrigger = document.querySelector(
      ".js-standard-shipping-modal-trigger"
    );
    this.elements.priorityModal = document.getElementById(
      "priority-shipping-modal"
    );
    this.elements.standardModal = document.getElementById(
      "standard-shipping-modal"
    );
    this.elements.modalHeaderCountryBtn = document.querySelector(
      ".js-delivery-show-list-country"
    );
    this.elements.modalCloseBtn = document.querySelector(
      ".js-close-delivery-modal"
    );
  }

  bindEvents() {
    // Open modal
    if (this.elements.openButton) {
      this.elements.openButton.addEventListener("click", (e) => {
        e.preventDefault();
        this.showModal();
      });
    }

    // Search functionality
    if (this.elements.searchInput) {
      this.elements.searchInput.addEventListener("input", (e) => {
        this.handleSearch(e.target.value);
      });
    }

    // Close modal when clicking outside
    if (this.elements.modal) {
      this.elements.modal.addEventListener("click", (e) => {
        if (e.target === this.elements.modal) {
          this.hideModal();
        }
      });
    }

    // Handle country selection
    if (this.elements.list) {
      this.elements.list.addEventListener("click", (e) => {
        const button = e.target.closest(".js-select-country");
        if (button) {
          this.selectCountry(
            button.dataset.code,
            button.dataset.name,
            button.dataset
          );
        }
      });
    }

    // Trigger open handlers
    if (this.elements.priorityTrigger) {
      this.elements.priorityTrigger.addEventListener("click", () => {
        this.updateAndShowShippingModal("priority");
      });
    }
    if (this.elements.standardTrigger) {
      this.elements.standardTrigger.addEventListener("click", () => {
        this.updateAndShowShippingModal("standard");
      });
    }

    // Close buttons on shipping modals
    document.querySelectorAll(".js-shipping-modal-close").forEach((btn) => {
      btn.addEventListener("click", () => {
        const m = btn.closest(".shipping-modal");
        if (m) m.classList.remove("show");
      });
    });

    // Delivery list modal close
    if (this.elements.modalCloseBtn) {
      this.elements.modalCloseBtn.addEventListener("click", (e) => {
        e.preventDefault();
        this.hideModal();
      });
    }
  }

  applyProductOverride() {
    try {
      const meta = window.productDeliveryMeta || {};

      if (!(meta.use_custom === true || meta.use_custom === "true")) {
        return;
      }

      const etaStr =
        meta.cn_eta && meta.cn_eta.trim() !== ""
          ? meta.cn_eta.trim()
          : meta.us_eta && meta.us_eta.trim() !== ""
          ? meta.us_eta.trim()
          : "";

      if (!etaStr) return;

      const parts = etaStr.split(";").map((s) => s.trim());
      const priorityRange = parts[0] || "";
      const standardRange = parts[1] || "";

      const parseRange = (str) => {
        const nums = (str.match(/\d+/g) || []).map((n) => parseInt(n, 10));
        if (nums.length === 1) return { min: nums[0], max: nums[0] };
        if (nums.length >= 2) return { min: nums[0], max: nums[1] };
        return { min: 0, max: 0 };
      };

      const pr = parseRange(priorityRange);
      const sr = parseRange(standardRange);

      const targetCode =
        meta.cn_eta && meta.cn_eta.trim() !== "" ? "CN" : "US";

      const row = this.countries.find(
        (c) => String(c["Country Code"]).toUpperCase() === targetCode
      );

      if (row) {
        row["Priority Shipping Order Ships"] = pr.min;
        row["Priority Shipping Arrives"] = pr.max;
        row["Standard Shipping Order Ships"] = sr.min;
        row["Standard Shipping Arrives"] = sr.max;

        console.log("Custom ETA applied for", targetCode, row);

        if (
          this.selectedCountry &&
          String(this.selectedCountry.code).toUpperCase() === targetCode
        ) {
          this.currentOffsets = {
            priorityOrderShips: pr.min,
            priorityArrives: pr.max,
            standardOrderShips: sr.min,
            standardArrives: sr.max,
          };
        }
      }

      this.filteredCountries = [...this.countries];
      this.renderCountries();
      this.updateArrivalTriggers();
      this.updateCurrentCountry();

    } catch (err) {
      console.warn("ETA override error:", err);
    }
  }



  async loadCountries() {
    if (this.isLoading) return;

    this.isLoading = true;
    this.showLoadingState();

    // 1) Use embedded data immediately (instant, < 1ms)
    const embeddedData =
      typeof deliveryDateData !== "undefined" &&
      Array.isArray(deliveryDateData.data)
        ? deliveryDateData.data
        : null;

    if (Array.isArray(embeddedData) && embeddedData.length > 0) {
      // Filter out empty entries
      const validData = embeddedData.filter(
        (c) => c["Country Code"] && c["Country Code"].trim() !== ""
      );

      this.countries = validData;
      this.filteredCountries = [...this.countries];
      this.renderCountries();
      this.setDefaultCountryFromBrowser();
      this.updateArrivalTriggers();
      this.applyProductOverride();
      this.isLoading = false; // Release UI immediately (instant)

      // 2) Wait for document to be ready, then fetch from API and replace
      const loadApiData = () => {

      };

      // Wait for document ready if not already loaded
      if (document.readyState === "loading") {
        document.addEventListener("DOMContentLoaded", loadApiData);
      } else {
        // Document already loaded, fetch immediately
        loadApiData();
      }

      return; // Exit early
    }

    // Fallback: if embedded data not available, fetch from API
    try {
      const response = await fetch(this.apiUrl);
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      const data = await response.json();
      const fresh = Array.isArray(data.data) ? data.data : [];
      if (fresh.length > 0) {
        this.countries = fresh;
        this.filteredCountries = [...this.countries];
        this.renderCountries();
        this.setDefaultCountryFromBrowser();
        this.updateArrivalTriggers();
      } else {
        throw new Error("No data available");
      }
    } catch (error) {
      console.error("Error loading countries:", error);
      this.showErrorState();
    } finally {
      this.isLoading = false;
    }
  }

  renderCountries() {
    if (!this.elements.list) return;

    this.elements.list.innerHTML = "";

    if (this.filteredCountries.length === 0) {
      this.elements.list.innerHTML =
        '<li class="no-results">No countries found</li>';
      return;
    }

    this.filteredCountries.forEach((country) => {
      if (!country["Country Code"] || country["Country Code"].trim() === "") {
        return;
      }
      const listItem = this.createCountryListItem(country);
      this.elements.list.appendChild(listItem);
    });
  }

  updateCurrentCountry() {
    if (!this.selectedCountry) return;
    this.updateCurrentCountryButton(this.selectedCountry.code, this.selectedCountry.name);
  }

  createCountryListItem(country) {
    const li = document.createElement("li");
    li.className = "delivery-widget__item";

    const button = document.createElement("button");
    button.className = "js-select-country";
    button.dataset.code = country["Country Code"] || "";
    const localizedName =
      this.getCountryDisplayName(country) || country["Country Name"] || "";
    button.dataset.name = localizedName;
    button.dataset.priority_shipping_order_ship =
      country["Priority Shipping Order Ships"] || "";
    button.dataset.priority_shipping_arrives =
      country["Priority Shipping Arrives"] || "";
    button.dataset.standard_shipping_order_ships =
      country["Standard Shipping Order Ships"] || "";
    button.dataset.standard_shipping_arrives =
      country["Standard Shipping Arrives"] || "";
    button.innerHTML = `<span class="fi fi-${
      country["Country Code"] || ""
    }"></span> ${localizedName}`;

    li.appendChild(button);
    return li;
  }

  handleSearch(query) {
    if (!query.trim()) {
      this.filteredCountries = [...this.countries];
    } else {
      this.filteredCountries = this.countries.filter((country) => {
        const name = (this.getCountryDisplayName(country) || "").toLowerCase();
        const code = (country["Country Code"] || "").toLowerCase();
        const searchTerm = query.toLowerCase();

        return name.includes(searchTerm) || code.includes(searchTerm);
      });
    }

    this.renderCountries();
  }

  selectCountry(code, name, dataset) {
    this.selectedCountry = { code, name };
    // Capture overrides from clicked element's data attributes (strings like "2-4")
    if (dataset) {
      this.currentOffsets = {
        priorityOrderShips: dataset.priority_shipping_order_ship || "",
        priorityArrives: dataset.priority_shipping_arrives || "",
        standardOrderShips: dataset.standard_shipping_order_ships || "",
        standardArrives: dataset.standard_shipping_arrives || "",
      };
    }

    // Update the current country button
    if (this.elements.currentCountryButton) {
      this.updateCurrentCountryButton(code, name);
    }

    // Trigger custom event for other components
    const event = new CustomEvent("deliveryCountryChanged", {
      detail: { code, name },
    });
    document.dispatchEvent(event);

    // Update arrival chips
    this.updateArrivalTriggers();

    this.hideModal();
  }

  updateCurrentCountryButton(code, name) {
    if (!this.elements.currentCountryButton) return;
    this.elements.currentCountryButton.dataset.code = code || "";
    this.elements.currentCountryButton.dataset.name = name || "";
    const flagCode = (code || "").toLowerCase();
    this.elements.currentCountryButton.innerHTML = `${name || ""}`;

    // Update flag container if present
    if (this.elements.currentCountryFlag) {
      this.elements.currentCountryFlag.innerHTML = flagCode
        ? `<span class="fi fi-${flagCode}"></span>`
        : "";
    }

    // Update modal header country button (with flag + name)
    if (this.elements.modalHeaderCountryBtn) {
      this.elements.modalHeaderCountryBtn.dataset.code = code || "";
      this.elements.modalHeaderCountryBtn.dataset.name = name || "";
      this.elements.modalHeaderCountryBtn.innerHTML = `<span class=\"fi fi-${flagCode}\"></span> ${
        name || ""
      }`;
    }
  }

  getBrowserCountryCode() {
    try {
      const langs = (
        navigator.languages && navigator.languages.length
          ? navigator.languages
          : [navigator.language || navigator.userLanguage]
      ).filter(Boolean);
      const candidates = [];
      langs.forEach((l) => {
        const parts = String(l).replace("_", "-").split("-");
        if (parts[1]) candidates.push(parts[1].toUpperCase());
      });
      const locale =
        (Intl &&
          Intl.DateTimeFormat &&
          Intl.DateTimeFormat().resolvedOptions().locale) ||
        "";
      const localeParts = String(locale).replace("_", "-").split("-");
      if (localeParts[1]) candidates.push(localeParts[1].toUpperCase());
      return candidates.find(Boolean) || "";
    } catch (_) {
      return "";
    }
  }

  setDefaultCountryFromBrowser() {
    // Always default to US
    const defaultCode = "US";
    if (!Array.isArray(this.countries) || this.countries.length === 0) {
      return;
    }
    const match = this.countries.find((c) => {
      const code = (c["Country Code"] || c.code || "").toString().toUpperCase();
      return code === defaultCode;
    });
    if (match) {
      const name =
        this.getCountryDisplayName(match) ||
        match["Country Name"] ||
        match.name ||
        defaultCode;
      this.updateCurrentCountryButton(defaultCode, name);
      this.selectedCountry = { code: defaultCode, name };
      // Initialize offsets from dataset (country row) when auto-selected
      this.currentOffsets = {
        priorityOrderShips: match["Priority Shipping Order Ships"] || "",
        priorityArrives: match["Priority Shipping Arrives"] || "",
        standardOrderShips: match["Standard Shipping Order Ships"] || "",
        standardArrives: match["Standard Shipping Arrives"] || "",
      };
    }
  }

  showModal() {
    if (this.elements.modal) {
      this.elements.modal.style.display = "flex";
      this.elements.modal.classList.add("show");
      document.body.classList.add("overflow-hidden");

      // Focus search input
      if (this.elements.searchInput) {
        setTimeout(() => {
          this.elements.searchInput.focus();
        }, 100);
      }
    }
  }

  hideModal() {
    if (this.elements.modal) {
      this.elements.modal.classList.remove("show");

      // Wait for animation to complete before hiding
      setTimeout(() => {
        this.elements.modal.style.display = "none";
      }, 300);

      document.body.classList.remove("overflow-hidden");

      // Clear search
      if (this.elements.searchInput) {
        this.elements.searchInput.value = "";
        this.handleSearch("");
      }
    }
  }

  showLoadingState() {
    if (this.elements.list) {
      this.elements.list.innerHTML =
        '<li class="loading">Loading countries...</li>';
    }
  }

  showErrorState() {
    if (this.elements.list) {
      this.elements.list.innerHTML =
        '<li class="error">Failed to load countries. Please try again.</li>';
    }
  }

  // Public method to get selected country
  getSelectedCountry() {
    return this.selectedCountry;
  }

  // Public method to set selected country
  setSelectedCountry(code, name) {
    this.selectCountry(code, name);
  }
}

// Initialize the component when DOM is ready
document.addEventListener("DOMContentLoaded", () => {
  window.deliveryDateComponent = new DeliveryDateComponent();
});
